import React, { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import api from "@/lib/api";
import AdminGameHub from "@/components/admin/AdminGameHub";
import { Newspaper, Eye, Users, FileEdit, TrendingUp, ArrowRight, MessageSquare } from "lucide-react";

export default function AdminDashboard() {
  const [stats, setStats] = useState(null);
  useEffect(() => { api.get("/admin/stats").then((r) => setStats(r.data)).catch(() => {}); }, []);

  if (!stats) return <div className="text-white/40">Loading dashboard…</div>;

  const cards = [
    { label: "Total Articles", value: stats.total_articles, icon: Newspaper, color: "hsl(var(--primary))" },
    { label: "Total Views", value: stats.total_views?.toLocaleString(), icon: Eye, color: "hsl(var(--accent))" },
    { label: "Published", value: stats.published, icon: TrendingUp, color: "#16a34a" },
    { label: "Drafts", value: stats.drafts, icon: FileEdit, color: "#f59e0b" },
    { label: "Accounts", value: stats.users, icon: Users, color: "#8b5cf6" },
    { label: "Comments", value: stats.comments, icon: MessageSquare, color: "#22c55e" },
  ];

  const maxViews = Math.max(1, ...stats.by_category.map((c) => c.views));

  return (
    <div>
      <div className="flex items-center justify-between mb-6">
        <div>
          <h1 className="text-2xl font-bold text-white">Dashboard</h1>
          <p className="text-sm text-white/50">Overview of your portal's content and traffic.</p>
        </div>
        <Link to="/admin/news" data-testid="dash-new-article" className="inline-flex items-center gap-2 px-4 py-2 rounded-full bg-[hsl(var(--primary))] text-white text-sm font-bold">
          Manage News <ArrowRight size={15} />
        </Link>
      </div>

      <div className="grid grid-cols-2 lg:grid-cols-6 gap-4">
        {cards.map((c) => (
          <div key={c.label} className="card-surface rounded-xl p-5">
            <c.icon size={20} style={{ color: c.color }} />
            <div className="mt-3 text-3xl font-bold font-head text-white">{c.value}</div>
            <div className="text-xs text-white/50 mt-1">{c.label}</div>
          </div>
        ))}
      </div>

      <div className="grid lg:grid-cols-2 gap-6 mt-6">
        <div className="card-surface rounded-xl p-5">
          <h3 className="font-bold text-white mb-4">Views by Category</h3>
          <div className="space-y-3">
            {stats.by_category.map((c) => (
              <div key={c.category}>
                <div className="flex justify-between text-sm mb-1">
                  <span className="text-white/70">{c.category}</span>
                  <span className="text-white/40">{c.views.toLocaleString()} views · {c.count} posts</span>
                </div>
                <div className="h-2 rounded-full bg-white/5 overflow-hidden">
                  <div className="h-full rounded-full" style={{ width: `${(c.views / maxViews) * 100}%`, background: "hsl(var(--primary))" }} />
                </div>
              </div>
            ))}
          </div>
        </div>

        <div className="card-surface rounded-xl p-5">
          <h3 className="font-bold text-white mb-4">Top Performing Articles</h3>
          <div className="space-y-1">
            {stats.top_articles.map((a, i) => (
              <div key={a.slug} className="flex items-center gap-3 py-2.5 border-b border-white/5 last:border-0">
                <span className="text-lg font-bold font-head text-white/20 w-6">{i + 1}</span>
                <div className="flex-1 min-w-0">
                  <div className="text-sm font-semibold text-white truncate">{a.title}</div>
                  <div className="text-xs text-white/40">{a.category}</div>
                </div>
                <span className="text-sm text-white/50 flex items-center gap-1"><Eye size={13} /> {a.views?.toLocaleString()}</span>
              </div>
            ))}
          </div>
        </div>
      </div>
      <AdminGameHub />
    </div>
  );
}
